export default "__VITE_ASSET__CWVZ3hwY__"